import * as R from 'ramda'

import schemaAt from 'coact/utils/schema/schemaAt'

import schemaModule from '../../utils/schema/index.js'

import { dataAccess } from '../purchaseOrder/index.js'

const schema = R.pipe(
  R.assocPath(['contents', 'orderRef'], {
    type: 'ObjectId',
    label: '進貨單號',
    reference: 'purchaseOrders',
    refKeys: ['key'],
  }),
  schemaModule.create,
)(schemaAt(['items', 0], dataAccess.schema))

export default {
  schema,
}
